<!--亲子课程预约-->
<template>
  <div class="app-container">

    <el-collapse v-model="activeNames">

      <!-- <el-collapse-item  name="1"> -->
      <!-- <template slot="title">
          <div class="title-container" shadow="never">
            <div class="title-con">
              <i class="el-icon-search"></i>
              <span style="margin-left: 5px;">筛选搜索</span>
            </div>
          </div>
        </template> -->
      <!--查询条件区域-->

      <!-- <el-card class="operate-container" shadow="never" style="margin-top: 0px;"> -->


      <div style="background: #FFFFFF;border-radius: 8px;padding: 24px 10px 2px 10px;text-align: left;">
        <el-form :inline="true" label-position="" :model="queryParam" label-width="80px">
          <el-form-item label="未来几天:" label-width="80px">
            <div class="future">
              <div :class="pitchUp == index ? 'future-btn' : 'future-btm'" v-for="(v, index) in redioWeek" :key="index"
                @click="clcikPitchUp(index, v)">
                {{ v.weekDay }}
              </div>
            </div>
          </el-form-item>
          <el-form-item label="会员手机号:" label-width="90px">
            <el-input v-model="queryParam.userPhone" placeholder="请输入手机号" style="width: 125px;"></el-input>
          </el-form-item>
          <el-form-item label="会员名:" label-width="60px">
            <el-input v-model="queryParam.childName" placeholder="请输入姓名" style="width: 100px;"></el-input>
          </el-form-item>
          <el-form-item label="上课日期:" label-width="80px">
            <el-date-picker @change="clickChanges" v-model="queryParam.times" type="date" placeholder="选择日期"
              style="width: 140px;" value-format="yyyyMMdd">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-refresh"
              @click="handleResetSearch()">重 置</el-button>
            <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查
              询</el-button>
          </el-form-item>
          <!-- <el-row>
                <el-col :span="6">
                  <el-form-item label="课程名称:">
                    <el-input v-model="queryParam.lessonName" placeholder="输入课程名称"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="会员姓名:">
                    <el-input v-model="queryParam.userChildrenName" placeholder="输入姓名"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="孩子小名:">
                    <el-input v-model="queryParam.userChildrenPetName" placeholder="输入小名"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="日期:">
                    <el-date-picker
                      v-model="queryParam.day"
                      value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="选择日期">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="卡号:">
                    <el-input v-model="queryParam.userPhone" placeholder="输入卡号"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-col :span="12">
                <el-form-item label="未来几天:">
                  <el-radio-group v-model="radio" @change="onChangeDay">
                <span v-for="(item,i) in redioWeek" :key="i" style="margin-right: 5px;">
                  <el-radio :label="i">{{item.weekDay}}</el-radio>
                </span>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="2"><div style="margin-top: 13px;font-size: 5px ;color: red">(点击立即查询)</div></el-col> -->
        </el-form>
      </div>
      <!-- <div class="button-container" style="margin-top: 0px">
            <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-refresh" @click="handleResetSearch()">重 置</el-button>
            <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查 询</el-button>
          </div> -->
      <!-- </el-card> -->
      <!-- </el-collapse-item> -->


    </el-collapse>


    <!--    查询结果区域-->
    <div class="title-container" shadow="never" style="margin-top: 20px;border: none;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
        <span style="margin-left: 5px;color:black;">TOTAL:{{totalChildren}}</span>
        <span style="margin-left: 5px;color:black;">NEW:{{totalChildren2}}</span>
      </div>
    </div>
      <!-- <div> -->
    <!-- <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-edit" @click="borrow()">消费</el-button> -->
    <!-- <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-edit" @click="handleBatchChangeBook()">更改时间</el-button>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-folder-checked" @click="handleBatchSingIn()">签到</el-button>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-folder-checked" @click="handleNotAttendBatchSingIn()">未到签到</el-button>
        <el-button type="danger" size="medium" class="operator-btn3" icon="el-icon-circle-close" @click="handleBatchCancel()">取消</el-button>
        <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-circle-check" @click="handleBatchPassBook()">确认通过</el-button>
        <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-circle-check" @click="handleExport()">导出</el-button> -->
    <!-- </div>
    </div> -->

    <div class="manage d-flex jc-end">
      <div class="spec-buton-box">
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search"
          @click="clickManage(1)">跟进</el-button>
        <img class="spec-img" src="@/statics/imgs/vip.png" alt="" />
      </div>

      <div class="spec-buton-box">
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search"
          @click="clickManage(2)">老师</el-button>
        <img class="spec-img" src="@/statics/imgs/vip.png" alt="" />
      </div>
      <div class="spec-buton-box">
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search"
          @click="clickManage(3)">洗澡</el-button>
        <img class="spec-img" src="@/statics/imgs/vip.png" alt="" />
      </div>
      <div class="spec-buton-box">
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search"
          @click="clickManage(4)">参数</el-button>
        <img class="spec-img" src="@/statics/imgs/vip.png" alt="" />
      </div>

      <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search"
        @click="clickManage(5)">消费</el-button>
      <div class="spec-buton-box">
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search"
          @click="handleNotAttendBatchSingIn()">未到签到</el-button>
        <img class="spec-img" src="@/statics/imgs/svip.png" alt="" />
      </div>

      <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search"
        @click="handleBatchSingIn()">签到</el-button>
      <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search"
        @click="clickManage(8)">改约</el-button>
      <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search"
        @click="clickManage(9)">取消</el-button>
      <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search"
        @click="handleExport(10)">导出</el-button>
      <div class="spec-buton-box">
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search"
          @click="clickManage(12)">课评</el-button>
        <img class="spec-img" src="@/statics/imgs/vip.png" alt="" />
      </div>
      <div class="spec-buton-box">
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search"
          @click="clickManage(11)">多媒体</el-button>
        <img class="spec-img" src="@/statics/imgs/vip.png" alt="" />
      </div>


    </div>
    <div class="table-container" style="margin-top: 0px;border: none;">
      <el-table :data="tableData" ref="seleteTable" style="font-size: 10px" max-height="650"
        :header-cell-style="{ 'text-align': 'center' }" :cell-style="cellStyle" v-loading="listLoading" border
        highlight-current-row :span-method="objectSpanMethod" @row-click="rowClick"
        @selection-change="handleSelectionChange">
        <!-- <el-table-column type="selection" width="55">
        </el-table-column> -->
        <el-table-column prop="classTime" label="时间" width="70"></el-table-column>
        <el-table-column prop="name" label="课程名" width="105"></el-table-column>
        <el-table-column prop="classRoomName" label="位置" width="80"></el-table-column>
        <el-table-column prop="maxBookPeople" label="容量" width="50"></el-table-column>
        <el-table-column prop="teachersInfo" label="上课老师" width="80"></el-table-column>
        <el-table-column prop="userPhoneNumber" label="会员手机号" width="125">
          <template slot-scope="scope">
            <div>
              <el-checkbox v-model="scope.row.checked" v-if="scope.row.userPhoneNumber">
              </el-checkbox>
              {{ scope.row.userPhoneNumber }}
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="userPhoneNumber" label="会员手机号" width="120"></el-table-column> -->
        <el-table-column prop="childName" label="会员名" width="70"></el-table-column>
        <el-table-column prop="monthCount" label="月龄" width="50"></el-table-column>
        <el-table-column prop="childLevel" label="级别" width="50"></el-table-column>
        <el-table-column prop="cardExperienceDisplay" label="卡种类" width="65"></el-table-column>
        <!-- <el-table-column prop="singInTime" label="签到时间" show-overflow-tooltip="true" width="130"></el-table-column> -->
        <el-table-column label="签到状态" width="80">
          <template slot-scope="scope">
            <div style="background-color: green;color: white" v-if="scope.row.singIn == 1 && scope.row.notAttendFlag">
              未到签到
            </div>
            <div style="background-color: green;color: white" v-if="scope.row.singIn == 1 && !scope.row.notAttendFlag">
              已签到
            </div>
            <div style="color: #6c829a" v-if="scope.row.singIn == 0">
              未签到
            </div>
            <div style="background-color:  chartreuse; color: white" v-if="scope.row.singIn == 3">
              待审核
            </div>
          </template>

        </el-table-column>
        <el-table-column prop="singInTime" label="签到时间" show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="remainingClass" label="余量" width="60"></el-table-column>
        <el-table-column label="课后服务" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.lessonEvaluationId == 1">课评</span>
            <span v-if="scope.row.multimediaId == 1">多媒体</span>
          </template>
        </el-table-column>
        <el-table-column prop="serviceWorker" label="服务老师" width="80"></el-table-column>
        <el-table-column prop="goodsName" label="消费" width="120"></el-table-column>
        <el-table-column prop="bathTeacher" label="洗澡" width="80"></el-table-column>
        <el-table-column prop="bookRemark" label="预约备注" show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="操作" width="70">
          <template slot-scope="scope">
            <div v-if="scope.row.notAttendFlag && scope.row.newLessonsId === null">
              <el-button @click="handleBookLesson(scope.row)" type="primary" size="small" plain>补课</el-button>
              <img class="spec-img" src="@/statics/imgs/svip.png" alt="" />
            </div>
          </template>
        </el-table-column>

        <!-- <el-table-column prop="bookRemark" label="预约备注"   show-overflow-tooltip="true"></el-table-column> -->
        <!-- <el-table-column prop="goodsName" label="消费商品"   v-if="false"></el-table-column>
        <el-table-column prop="goodsId" label="商品ID" v-if="false"></el-table-column> -->
        <!-- <el-table-column label="操作">
          <template slot-scope="scope">
            <el-dropdown split-button size="mini" type="primary" v-if="scope.row.needSetTeacherFlag">
            指定教师
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="item in scope.row.teacherList" @click.native="setServiceTeacher(scope.row, item)" :key="item.id">
              {{ item.name }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->

        <!-- <el-select v-if="scope.row.needSetTeacherFlag"  v-model="scope.row.selectedTeacher" size="small">
              <el-option v-for="item in scope.row.teacherList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
            <el-button v-if="scope.row.needSetTeacherFlag" type="primary" size="small" class="operator-btn" @click="setServiceTeacher(scope.row)" >指定教师</el-button> -->
        <!-- <el-button v-if="scope.row.needServiceFlag" type="primary" size="mini" class="operator-btn" @click="doAfterService(scope.row)" >服务</el-button> -->
        <!--消费商品-->
        <!-- <div  v-if="scope.row.userPhoneNumber != null ">
              <el-button  @click="borrow(scope.row)" type="primary" size="small" plain>消费 </el-button>
            </div>
            <div  v-if="scope.row.notAttendFlag && scope.row.newLessonsId === null ">
              <el-button  @click="handleBookLesson(scope.row)" type="primary" size="small" plain>补课预约</el-button>
            </div>
              <el-dropdown split-button size="mini" type="primary" v-if="scope.row.needSetBathWorker">
                洗澡人员
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="item in storeWokers" @click.native="setBathWorker(scope.row, item)" :key="item.id">
                  {{ item.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <!-- 补课预约课程-->
    <el-dialog title="补课预约课程" :visible.sync="visibleDlgBook" v-if="visibleDlgBook" width="50%" center>
      <el-form label-width="120px">
        <el-form-item label="选课上课日期:">
          <el-date-picker style="width: 270px" @change="changeDay" v-model="bookInfo.dayTime" type="date"
            placeholder="选择日期" value-format="yyyy-MM-dd" :picker-options="setDateRange">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="选择课程:">
          <el-select v-model="bookInfo.storeReleaseLessonId" placeholder="请选择" style="width: 270px">
            <el-option v-for="item in storeReleaseLessons" :key="item.id" :label="praseLessonName(item)" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否补发课时:">
          <el-radio-group v-model="bookInfo.refundFlag">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer-1">
        <el-button type="danger" @click="onClickBookLesson()">预约</el-button>
      </div>
    </el-dialog>
    <!--审核弹窗-->
    <el-dialog title="审核预约" :visible.sync="visibleDlgExamine" width="50%" center>
      <div>
        <el-form ref="registerRef" label-width="150px">
          <el-card style="margin-top: -20px;">
            <span>课程信息</span>
            <el-form-item label="课程名:">
              <el-input readonly="true" style="width: 300px;" v-model="examineParam.lessonName"></el-input>
            </el-form-item>
          </el-card>
          <el-card style="margin-top: 10px;">
            <span>孩子信息</span>
            <el-form-item label="会员姓名:">
              <el-input readonly="true" style="width: 300px;" v-model="examineParam.childName"></el-input>
            </el-form-item>
            <el-form-item label="孩子小名:">
              <el-input readonly="true" style="width: 300px;" v-model="examineParam.childPetName"></el-input>
            </el-form-item>
            <el-form-item label="孩子课程等级:">
              <el-input readonly="true" style="width: 300px;" v-model="examineParam.childLevel"></el-input>
            </el-form-item>
          </el-card>
          <el-card style="margin-top: 10px;">
            <span>家长信息</span>
            <el-form-item label="家长姓名:">
              <el-input readonly="true" style="width: 300px;" v-model="examineParam.userName"></el-input>
            </el-form-item>
            <el-form-item label="家长手机号:">
              <el-input readonly="true" style="width: 300px;" v-model="examineParam.userPhone"></el-input>
            </el-form-item>
          </el-card>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="handeleExamine(false)">不通过</el-button>
        <el-button type="success" @click="handeleExamine(true)">确认通过</el-button>
      </span>
    </el-dialog>
    <!--取消预约弹窗-->
    <el-dialog title="取消预约" :visible.sync="visibleCancel" width="50%" center>
      <el-form ref="registerRef" label-width="150px">
        <el-form-item label="取消原因:">
          <el-input readonly="true" style="width: 300px;" v-model="cancleBook.cancelReason"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="visibleCancel = false">取消</el-button>
        <el-button type="success" @click="handeleCancelBook">确认</el-button>
      </span>
    </el-dialog>
    <!--课后服务-->
    <!-- <el-dialog
      title="课后服务"
      :visible.sync="visibleAfterClassService"
      width="50%"
      center>
      <after-class-service :key="afterClassServiceDetailrefresh"  @onBtnOK="onBtnOKSerivce" v-bind:detail="afterClassServiceDetail"></after-class-service>
    </el-dialog>
    <el-dialog
      title="课后服务详情"
      :visible.sync="visibleAfterClassServiceDetail"
      width="50%"
      center>
      <after-class-service :key="afterClassServiceDetailrefresh"  @onBtnOK="onBtnOKSerivce" v-bind:detail="afterClassServiceDetail"></after-class-service>
    </el-dialog> -->
    <!--选择借用商品-->
    <el-dialog title="消费" :visible.sync="visibleSth" width="50%" center>
      <el-form ref="registerRef" label-width="150px">
        <el-form-item label="ID:" v-if="false">
          <el-input readonly="true" style="width: 300px;" v-model="updateParam.id"></el-input>
        </el-form-item>
        <el-form-item label="物品ID:" v-if="false">
          <el-input readonly="true" style="width: 300px;" v-model="updateParam.goodsId"></el-input>
        </el-form-item>
        <el-form-item label="卡号:" v-if="false">
          <el-input readonly="true" style="width: 300px;" v-model="updateParam.userBuyCardId"></el-input>
        </el-form-item>
        <el-form-item label="用户:" v-if="false">
          <el-input readonly="true" style="width: 300px;" v-model="updateParam.userId"></el-input>
        </el-form-item>
        <el-checkbox-group v-model="checkList">
          <el-checkbox v-for="filter in goodsList" :key="filter.value" :label="filter.value">{{ filter.text
          }}</el-checkbox>
        </el-checkbox-group>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="visibleSth = false">取消</el-button>
        <el-button type="success" @click="handleBorrowGoods">确认</el-button>
      </span>
    </el-dialog>

    <el-dialog title="选择课程" :visible.sync="visibleDlgSelectLesson" width="50%" center>
      <select-day-release-lesson @onSelectLesson="onSelectLesson"></select-day-release-lesson>
    </el-dialog>
    <el-dialog title="课后服务" :visible.sync="visibleAfterClassService" width="50%" center>
      <after-class-service v-bind:service-items="serviceItems" :key="afterClassServiceDetailrefresh"
        @onBtnOK="onBtnOKAfterService" v-bind:detail="serviceRow"></after-class-service>
    </el-dialog>
    <!-- <worker-word :key="refreshWord" :word-type="wordType" :t-data="tData" :show="showWordDlg"
      @onWorkerWord="handleWord"></worker-word> -->



    <!-- 跟进安排 -->
    <el-dialog title="跟进安排" :visible.sync="followUp" width="40%" center>
      <el-form ref="userForm" label-width="100px" :model="userForm" :rules="userFormRules">
        <div style="display: flex;">
          <el-form-item label="手机号" prop="userPhoneNumber">
            <el-input disabled v-model="userForm.userPhoneNumber" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="生日">
            <el-input disabled v-model="userForm.userBirthday" autocomplete="off"></el-input>
          </el-form-item>
        </div>
        <div style="display: flex;">
          <el-form-item label="会员姓名" prop="childName">
            <el-input disabled v-model="userForm.childName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="性别">
            <el-input disabled v-model="userForm.gender" autocomplete="off"></el-input>
          </el-form-item>
        </div>
        <div style="display: flex;">
          <el-form-item label="小名">
            <el-input disabled v-model="userForm.childPetName" autocomplete="off"></el-input>
          </el-form-item>
        </div>
        <div style="display: flex;">
          <el-form-item label="跟进人">
            <div style="display: flex;flex-wrap: wrap;">
              <div style="display: flex;align-items: center;margin-bottom: 10px;" v-for="(v, index) in userForm.teaching">
                <el-select v-model="v.assistant" placeholder="请选择" style="width: 240px" clearable="">
                  <el-option v-for="fk in selectAllList" :key="fk.id" :label="fk.name" :value="fk.id" :disabled="v.assistant == fk.id ||
                    userForm.teaching
                      .map((mk) => {
                        return Number(mk.assistant);
                      })
                      .includes(fk.id)
                    ? true
                    : false
                    ">
                  </el-option>
                </el-select>
                <img v-if="index == 0" src="../../statics/imgs/jh.png" alt=""
                  style="width: 25px;margin-left: 5px;height: 25px;margin-right: 10px;" @click="clickAddWordks">
                <img v-else src="../../statics/imgs/jih.png" @click="clickClearWorks(index)" alt=""
                  style="margin-right: 10px;width: 25px;margin-left: 5px;height: 25px;">
              </div>
            </div>
          </el-form-item>
        </div>
        <div style="display: flex;">
          <el-form-item label="跟进时间" prop="recordDateTime">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="userForm.recordDateTime" type="datetime"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
        </div>
        <el-form-item label="跟进内容">
          <el-input v-model="userForm.followContent" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit">保 存</el-button>
        <el-button @click="resetForm">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 老师分配 -->
    <el-dialog title="分配" :visible.sync="distribution" width="30%" center>
      <el-form ref="teacherAllot" label-width="100px" :model="teacherAllot">
        <el-form-item label="上课老师：">
          <el-select v-model="teacherAllot.serviceTeacher" placeholder="下拉选择老师">
            <el-option v-for="item in selectAllList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="teacherAllots">保 存</el-button>
        <el-button @click="distribution = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 洗澡分配 -->
    <el-dialog title="分配" :visible.sync="takeBath" width="30%" center>
      <el-form ref="teacherAllot" label-width="100px" :model="teacherAllot">
        <el-form-item label="洗澡老师：">
          <el-select v-model="teacherAllot.batherTeacherId" placeholder="下拉选择老师">
            <el-option v-for="item in selectAllList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="setBathWor">保 存</el-button>
        <el-button @click="takeBath = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 参数设定 -->
    <el-dialog title="参数设定" :visible.sync="Settings" width="50%">
      <div>
        <el-radio :disabled="disabledtd" v-model="radio" label="1">默认关闭</el-radio>
        <el-radio :disabled="disabledtd" v-model="radio" label="2">打开(需要购买权限)</el-radio>
      </div>
      <el-form :model="updateFrom" label-width="120px">
        <el-form-item label="预约设置">
          <el-radio-group v-model="updateFrom.appointmentRule">
            <el-radio :label="false">关闭</el-radio>
            <el-radio :label="true">开启</el-radio>
          </el-radio-group>
        </el-form-item>
        <div style="display: flex;align-items: center;">
          <el-form-item label="开课前" style="width: 50%;">
            <div style="display: flex;">
              <el-input v-model="updateFrom.appointmentTime" autocomplete="off"
                style="width: 50%;margin-right: 20px;"></el-input>
              <span>小时内不可预约</span>
            </div>
          </el-form-item>
          <el-form-item label="开课前" style="width: 50%;">
            <div style="display: flex;">
              <el-input v-model="updateFrom.cancelTime" autocomplete="off"
                style="width: 50%;margin-right: 20px;"></el-input>
              <span>小时内不可取消</span>
            </div>
          </el-form-item>
        </div>
        <div style="display: flex;align-items: center;">
          <el-form-item label="开课前" style="width: 50%;">
            <div style="display: flex;">
              <el-input v-model="updateFrom.signBeforeTime" autocomplete="off"
                style="width: 50%;margin-right: 20px;"></el-input>
              <span>小时内签到</span>
            </div>
          </el-form-item>
          <el-form-item label="开课后" style="width: 50%;">
            <div style="display: flex;">
              <el-input v-model="updateFrom.signAfterTime" autocomplete="off"
                style="width: 50%;margin-right: 20px;"></el-input>
              <span>小时内签到</span>
            </div>
          </el-form-item>
        </div>
        <div style="display: flex;align-items: center;">
          <el-form-item label="未到签到" style="width: 50%;">
            <div style="display: flex;">
              <el-input v-model="updateFrom.notAttendSignDay" autocomplete="off"
                style="width: 50%;margin-right: 20px;"></el-input>
              <span>天内可预约</span>
            </div>
          </el-form-item>
        </div>
        <div style="display: flex;align-items: center;">
          <el-form-item label="剩余课时阈值" style="width: 50%;">
            <div style="display: flex;">
              <el-input v-model="updateFrom.parentingSurplusHours" autocomplete="off"
                style="width: 50%;margin-right: 20px;"></el-input>
            </div>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button type="primary" @click="updateTempl">保 存</el-button>
        <el-button @click="Settings = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 消费 -->
    <el-dialog title="消费" :visible.sync="consume" width="40%" center>
      <div>
        购买商品：
      </div>
      <div>
        <div style="display: flex;align-items: center;margin-top: 15px;" v-for="(v, index) in form" :key="index">
          <div style="margin-right: 15px;">
            <el-select v-model="v.goodsId" placeholder="下拉选择商品">
              <el-option v-for="item in searchList" :key="item.goodsId" :label="item.goodsName" :value="item.goodsId">
              </el-option>
            </el-select>
          </div>
          <div>
            <el-select v-model="v.payWay" placeholder="下拉选择付款方式">
              <el-option v-for="item in options" :key="item.id" :label="item.label" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <img v-if="index == 0" src="../../statics/imgs/jh.png" alt=""
            style="width: 25px;margin-left: 5px;height: 25px;margin-right: 10px;" @click="clickProduct">
          <img v-else src="../../statics/imgs/jih.png" @click="deleProduct(index)" alt=""
            style="margin-right: 10px;width: 25px;margin-left: 5px;height: 25px;">
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="borrows">保 存</el-button>
        <el-button @click="consume = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 更改时间 -->
    <el-dialog title="更改时间" :visible.sync="changeTime" width="30%" center>
      <el-form ref="qLessonsForm" label-width="100px" :model="qLessonsForm" :rules="qLessonsForms">
        <el-form-item label="手机号" prop="userPhoneNumber">
          <el-input disabled v-model="qLessonsForm.userPhoneNumber" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="会员姓名" prop="childName">
          <el-input disabled v-model="qLessonsForm.childName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="小名">
          <el-input disabled v-model="qLessonsForm.childPetName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="更改日期" prop="dayTime">
          <el-date-picker @change="changeQLesson" v-model="qLessonsForm.dayTime" type="date" placeholder="选择日期"
            value-format="yyyyMMdd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="选择课程">
          <el-select v-model="qLessonsForm.oldBookId" placeholder="下拉选择课程" @change="clickChange">
            <!-- :label="item.name" -->
            <el-option v-for="item in qLessonsList" :key="item.id" :label="praseLessonName(item)" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="更改时间" prop="classStartTime">
          <el-time-picker disabled style="width: 150px" v-model="qLessonsForm.classStartTime" format="HH:mm"
            value-format="HHmm" :picker-options="{ selectableRange: '00:00:00- 23:59:59' }" placeholder="上课时间">
          </el-time-picker>
          <span>-</span>
          <el-time-picker disabled style="width: 150px" v-model="qLessonsForm.classEndTime" format="HH:mm"
            value-format="HHmm" :picker-options="{ selectableRange: '00:00:00- 23:59:59' }" placeholder="下课时间">
          </el-time-picker>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmitt('ruleForm')">保 存</el-button>
        <el-button @click="changeTime = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 取消 -->
    <el-dialog title="取消" :visible.sync="abolish" width="30%" center>
      <el-form ref="batcheList" label-width="100px" :model="batcheList" :rules="userFormRules">
        <el-form-item label="会员名">
          <el-input disabled v-model="batcheList.childName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="会员手机号">
          <el-input disabled v-model="batcheList.userPhoneNumber" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="batcheCancel">保 存</el-button>
        <el-button @click="abolish = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 课评 -->
    <el-dialog :visible.sync="evaluation" title="课评" width="30%" center>
      <div class="overflow-hidden">
        <comment :currentType="currentType" ref="commentRef" :courseRocordId="checkedId" :defaultConfig="defaultConfig"
          :swimInfoTable="swimInfoTable" :listtstt="getCheckedChild()" :commentID="2"></comment>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button :loading="buttonLoading" type="primary" @click="handleMaintainSubmit">提 交</el-button>
        <el-button @click="evaluation = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- <el-dialog title="课评" :visible.sync="evaluation" width="30%" center>
      <el-form ref="userForm" label-width="100px" :model="userForm" :rules="userFormRules">
        <div v-for="(v, index) in dimensions" :key="index">
        <el-form-item :label="v.name">
          <el-input v-model="v.field" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="userForm.phone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="身高">
          <el-input v-model="userForm.phone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="体重">
          <el-input v-model="userForm.phone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="游泳时长">
          <el-input v-model="userForm.phone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="泳圈">
          <el-input v-model="userForm.phone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="其他内容">
          <el-input v-model="userForm.phone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="金币">
          <el-input v-model="userForm.phone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="userForm.phone" autocomplete="off"></el-input>
        </el-form-item>
      </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit">保 存</el-button>
        <el-button @click="evaluation = false">取 消</el-button>
      </span>
    </el-dialog> -->

    <!-- 多媒体弹窗 -->
    <el-dialog :visible.sync="visibleMultimedia" title="多媒体上传" width="30%" center>
      <div class="overflow-hidden">
        <multimediaVue ref="multimediaRef" :courseRocordId="checkedId" :defaultConfig="defaultConfig"
          :currentRow="getCheckedChild()[0]"></multimediaVue>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handlMultimeSubmit">提 交</el-button>
        <el-button @click="visibleMultimedia = false">取 消</el-button>
      </div>
    </el-dialog>
    <worker-word ref="workerWord" :key="refreshWord" :word-type="wordType" :t-data="tData" :show="showWordDlg"
      @onWorkerWord="handleWord"></worker-word>
  </div>
</template>

<script>
import multimediaVue from "./components/multimedia";
import commonUtils from "../../utils/commonUtils";
import globaldata from "../../utils/globaldata";
import WorkerWord from "@/components/WorkerWord/WorkerWord";
import {
  adminSign, batchAdminPassBook,
  batcheCancelBook,
  batcheChangeBook,
  batcheSingIn,
  fechListUserBookLesson,
  passbook,
  borrowGoods,
  selectAllGET,
  releaselessonGET,
  teacherAllotPOST,
  searchGET,
  borrowGoodsGET,
  qLessonsGET,
  updateTemplateSetting,
  findTemplateById,
  commitRecord
} from "../../api/userBookLesson";
import { qlDayReleaseLessons, lessonsGET } from "../../api/StoreReleaseLesson";
import messageUtils from "../../utils/messageUtils";
import AfterClassService from "../my-store/component/AfterClassService";
import timeUtils from "../../utils/timeUtils";
import enumsUtil from "../../utils/enumsUtil";
import { fechListReleaseLessonDetail } from "../../api/StoreReleaseLesson";
import { formatDate } from "../../utils/date";
import SelectDayReleaseLesson from "../components/SelectDayReleaseLesson";
import ExportJsonExcel from 'js-export-excel';
// import WorkerWord from "../../components/WorkerWord/WorkerWord";
import { setServiceTeacher, workerService, setBathWorker, updateCourseEval, updateCourseMedia } from "../../api/AfterClassService";
import { getClassServiceAllItem, getClassServiceItem, qlSwCircle } from "../../api/StoreSetting";
import { queryGoods } from "../../api/Goods";
import { adminNotAttendBookLesson } from "@/api/userBookLesson";
import { findStoreById } from "../../api/storeFront";
import comment from "../service/course-evaluation-A/components/comment.vue";
export default {
  components: { SelectDayReleaseLesson, AfterClassService, WorkerWord, multimediaVue, comment },
  data() {
    return {
      disabledtd:true,
      currentType: 'B',
      buttonLoading: false, //按钮loading
      dimensions: [], // 课评弹窗
      selectionList: [], // 表格选中数据
      checkedData: {}, //选中的项
      defaultConfig: {},
      swimInfoTable: [], //泳圈数据列表
      checkedId: null, //选中的id
      radio: '1',
      userFormRules: {
        name: [
          { required: true, message: '请输入会员姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'change' }
        ],
        time: [
          { type: 'date', required: true, message: '请选择跟进日期', trigger: 'change' }
        ]
      },
      qLessonsForms: {
        userPhoneNumber: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        childName: [
          { required: true, message: '请输入会员姓名', trigger: 'change' }
        ],
        dayTime: [
          { type: 'date', required: true, message: '请选择更改日期', trigger: 'change' }
        ],
        classStartTime: [
          { type: 'date', required: true, message: '请选择更改时间', trigger: 'change' }
        ],
      },
      batcheList: {
        childName: '', //
        userPhoneNumber: '', //
      },
      redioWeek: [
        { day: 0, weekDay: '' },
        { day: 0, weekDay: '周三' },
        { day: 0, weekDay: '' },
        { day: 0, weekDay: '' },
        { ay: 0, weekDay: '' },
        { day: 0, weekDay: '' },
        { day: 0, weekDay: '' },
      ],
      selectAllList: [], // 查询老师数据
      options: [{
        id: '1',
        label: '现金'
      }, {
        id: '2',
        label: '微信'
      }],
      workerWordID: 0,
      input: '',
      form: [{
        goodsId: '',
        payWay: ''
      }],
      teacherAllot: {
        serviceTeacher: '', //服务老师id
        batherTeacherId: '', // 洗澡老师id
      },
      qLessonsForm: {
        userPhoneNumber: '',// 手机号
        childName: '',
        childPetName: '',
        dayTime: '',
        oldBookId: '',
        classStartTime: '',
        classEndTime: ''
      },
      qLessonsList: [],
      userForm: {
        cardId: '',
        userId: '',
        userPhoneNumber: '',// 手机号
        childName: '', // 会员姓名
        childPetName: '', // 小名
        gender: '',//性别
        userBirthday: '',// 生日
        recordDateTime: '', //跟进时间
        followContent: '',//跟进内容
        teaching: [{
          assistant: ''
        }],
      },
      followUp: false,// 跟进安排弹窗
      distribution: false, // 老师分配弹窗
      takeBath: false, //洗澡分配弹窗
      Settings: false, // 参数设定弹窗
      consume: false, // 消费弹窗
      changeTime: false, // 更改时间
      abolish: false, // 取消弹窗
      visibleMultimedia: false, // 多媒体
      evaluation: false, // 课评弹窗
      pitchUp: 0,
      pitchList: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      //店铺发布的课程
      storeReleaseLessons: [],
      bookInfo: {},
      activeNames: ['1'],
      listLoading: true,
      visibleDlgBook: false,
      storeLessonTemplateList: [],
      storeSwCircleList: [],
      storeWokers: [],
      //弹窗
      visibleDlgAdd: false,
      visibleDlgExamine: false, //审核弹窗
      visibleCancel: false,     //取消预约
      visibleAfterClassService: false,     //课后服务
      visibleAfterClassServiceDetail: false,     //课后服务详情
      visibleDlgSelectLesson: false, //选择发布的课程
      showWordDlg: false, //输入口令
      AfterClassServiceType: 0,
      // radio: 0,
      redioWeek: [
        { day: 0, weekDay: '' },
        { day: 0, weekDay: '周三' },
        { day: 0, weekDay: '' },
        { day: 0, weekDay: '' },
        { ay: 0, weekDay: '' },
        { day: 0, weekDay: '' },
        { day: 0, weekDay: '' },
      ],
      redioDay: null,
      searchList: [],
      checkList: [],
      allGoodsList: [],
      //cities: cityOptions,
      goodsName: "",
      goodsList: [{
        value: "",
        text: "",
      }],
      //查询参数
      queryParam: {
        lessonName: '',//课程名称
        userName: '',
        userPhone: '', //家长手机号
        userChildrenName: '',
        userChildrenPetName: '',
        userChildrenLevelDes: '',
        optionsSignStatuValue: "",
        optionsBookStatuValue: "",
        userPhoneNumber: '',
        childName: '',
        // dayTime:new Data(),
        day: null,
        days: '',
        times: '',
        //分页查询
        pageNum: 1,//当前第几页
        totalPage: 1, //总共页数
        pageSize: 10,
        pageSizes: [20, 50, 100],
      },
      optionsSignStatu: [
        {
          value: null,
          label: "所有",
        },
        {
          value: 0,
          label: "未签到",
        },
        {
          value: 1,
          label: "已签到",
        }
      ],
      optionsBookStatu: [
        {
          value: 1,
          label: "预约成功",
        },
        // {
        //   value:2,
        //   label:"取消预约",
        // },
        {
          value: 3,
          label: "等待审核",
        },
        // {
        //   value:4,
        //   label:"已完成",
        // }
      ],

      //审核参数
      examineParam: {
        id: "",
        lessonName: '',//课程名称
        userName: '',
        userPhone: '', //家长手机号
        childName: '',
        childPetName: '',
        childLevel: 0,
        examineReason: ''
      },
      updateParam: {
        id: "",
        storeFrontId: "",
        goodsId: "",
        checkList: "",
      },
      cancleBook: {


      },

      singInParam: {
        id: "",
      },

      storeFront: {},
      //表单结果
      tableData: [
      ],
      updateFrom: {},
      spanArr: [],
      pos: 0,

      //添加参数
      createParam: {
        payTime: '',
        cardTime: '',
        storeLessonCardId: '1001',
        remark: '备注',// 剩余课时
        userPhone: '', //家长手机号
      },

      allClassroom: [],
      //课后服务参数
      afterClassServiceDetail: {},
      afterClassServiceDetailrefresh: "",
      curDay: "",//当前日期
      totalChildren: 0,
      totalChildren2: 0,
      refreshWord: new Date().getTime(),
      selectRow: null,
      showWordDlg: false,
      tData: {
        adminWord: ''
      },
      wordType: 0,
      visibleSth: false,//借用物品弹出
      serviceRow: null,
      serviceItems: [],
      afterClassServiceDetailrefresh: "",
      setDateRange: {
        disabledDate: time => {
          // 只能选择当前 1 年内的时间
          // const year = 365 * 24 * 3600 * 1000;
          // 只能选择当前 1 月的时间
          // const month = 30 * 24 * 3600 * 1000;
          // 只能选择当前 1 周的时间
          const week = 7 * 24 * 3600 * 1000;
          // 返回小于当前日期并近【1年】【1月】【1周】内的日期
          // 注意：这是从当前日期开始往前算，如果当前日期可选的话，不要写【-8.64e7】
          // return time.getTime() > Date.now() || time.getTime() < (Date.now() - 8.64e7) - year;
          // 禁用今天之前的日期【当前天可选】
          // return time.getTime() < Date.now() - 8.64e7;
          // 禁用今天之前的日期【当前天不可选】
          return time.getTime() < Date.now() || time.getTime() > (Date.now() + week);
          // 禁用今天之后的日期【当前天不可选】
          // return time.getTime() > Date.now() - 8.64e7;
          // 禁用今天之后的日期【当前天可选】
          // return time.getTime() > Date.now();
        }
      },
      isVip: globaldata.getAdminStore().isVip,
    }
  },
  created() {
    globaldata.getClassroom(this.getClassroom);
    globaldata.getStoreSwimCircle(this.getStoreSwimCircle);
    globaldata.getStoreWorkersInfo(this.getStoreWorkersInfo);
    globaldata.getStoreGoods(this.getStoreGoods);
    this.getGoodsList();
    this.calRedioDay()
  },
  mounted() {
    this.qlSwCircle()

    let param = { id: globaldata.getAdminStore().storeFrontId, }
    findStoreById(param).then(response => {
      let data = response.data;
      if (commonUtils.isObjectNull(data)) {
        return;
      }
      this.storeFront = data;
      let dateRang = {
        disabledDate: time => {
          const day = this.storeFront.notAttendSignDay * 24 * 3600 * 1000
          return time.getTime() < Date.now() || time.getTime() > (Date.now() + day)
        }
      }
      this.setDateRange = dateRang
    })

  },
  methods: {
    updateTempl() {
      updateTemplateSetting({ ...this.updateFrom, shopFrontId: globaldata.getAdminStore().storeFrontId, template: 1 ,radio:this.radio}).then((res) => {
        if (res.code == 20000) {
          messageUtils.successMsg(this, "参数设定成功")
          this.Settings = false
          this.flechList();
        }
      })
    },
    // 取消确认
    batcheCancel() {
      let listtst = this.getCheckedChild();
      let params = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        adminId: globaldata.getAdminStore().id,
        adminWord: "",
        reaseon: "",
        items: [{
          id: listtst[0].userBookLessonId,
          childName: listtst[0].userId
        }]
      }
      batcheCancelBook(params).then((res) => {
        if (res.code == 20000) {
          messageUtils.successMsg(this, "取消成功")
          this.abolish = false
          this.flechList();
        }
      })
    },
    // 更改日期
    changeQLesson() {
      this.qLessons()
    },
    clickChange(val) {
      this.qLessonsList.forEach((item) => {
        if (item.id == val) {
          this.qLessonsForm.classStartTime = JSON.stringify(item.classStartTime)
          this.qLessonsForm.classEndTime = JSON.stringify(item.classEndTime)
        }
      })
    },
    //选择上课日期
    qLessons() {
      let param = {
        lessonTemplateId: 1,
        dayTime: this.qLessonsForm.dayTime,
        storeFrontId: globaldata.getAdminStore().storeFrontId
      }
      qLessonsGET(param).then((res) => {
        // if(res.data == 20000){
        this.qLessonsList = res.data
        // }
      })
    },
    borrows() {
      let listt = this.getCheckedChild();
      // console.log(listt[0],'listt[0]-=========')
      let cardList = []
      let data = {
        cardId: listt[0].userBuyCardId,
        userId: listt[0].userId,
      }
      cardList.push(data);
      let param = {
        cardList: cardList,
        userBookLessonId: listt[0].userBookLessonId,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        goodsPayWays: this.form
      }
      console.log(param, 'user/lessons/borrowGoods')
      // return
      borrowGoodsGET(param).then((res) => {
        if (res.code == 20000) {
          messageUtils.successMsg(this, "批量消费成功")
          this.consume = false
          this.flechList();
        }
      })
    },
    // 老师分配
    teacherAllots() {
      this.$refs['workerWord'].param.word = ''
      this.$refs['workerWord'].showDlog = true
      this.workerWordID = 1
    },
    findTemp() {
      let params = {
        template: 1,
        id: globaldata.getAdminStore().storeFrontId
      }
      findTemplateById(params).then((res) => {
        console.log(res, '==============')
        if (res.code == 20000) {
          this.updateFrom = res.data
        }
      })
    },
    //洗澡老师分配
    setBathWor() {
      this.$refs['workerWord'].param.word = ''
      this.$refs['workerWord'].showDlog = true
      this.workerWordID = 2
    },
    clickAddWordks() {
      let self = this;
      self.userForm.teaching.push({ assistant: "" });
    },
    clickClearWorks(index) {
      this.$delete(this.userForm.teaching, index);
    },
    //查询老师接口
    selectAll() {
      selectAllGET({ storeFrontId: globaldata.getAdminStore().storeFrontId }).then((res) => {
        if (res.code == 20000) {
          this.selectAllList = res.data
        }
      })
    },
    selectAllS(v) {
      // console.log(v[0].id,'==========')
      // return
      releaselessonGET({ storeReleaseLesson: v[0].id }).then((res) => {
        if (res.code == 20000) {
          this.selectAllList = res.data
        }
      })
    },
    // 多媒体弹窗提交按钮事件
    handlMultimeSubmit() {
      this.$refs['workerWord'].param.word = ''
      this.$refs['workerWord'].showDlog = true
      this.workerWordID = 4
      return
      let self = this
      console.log(self.$refs.multimediaRef.$refs.soundRecord.audio, 'self.$refs.multimediaRef.$refs.soundRecord.audio===========')

      let listtst = this.getCheckedChild();
      let params = {
        identityId: listtst[0].userBookLessonId,
        video: self.$refs.multimediaRef.multimediaForm.video,
        image: self.$refs.multimediaRef.multimediaForm.image,
        remark: self.$refs.multimediaRef.multimediaForm.remark,
        audio: self.$refs.multimediaRef.$refs.soundRecord.audio
      };
      self.buttonLoading = true;
      updateCourseMedia(params)
        .then((response) => {
          if (response.code == 20000) {
            self.$message.success("提交成功");
            self.visibleMultimedia = false;
            self.checkedId = null
            self.$nextTick(() => {
              self.$refs.multimediaRef.resetForm()

            })
            self.getList();
          }
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
    // 课评弹窗提交事件
    handleMaintainSubmit() {
      this.$refs['workerWord'].param.word = ''
      this.$refs['workerWord'].showDlog = true
      this.workerWordID = 3
      return
      let self = this
      let comment = {};
      if (this.$refs.commentRef.courseForm.dimensions && this.$refs.commentRef.courseForm.dimensions.length) {
        this.$refs.commentRef.courseForm.dimensions.map((item) => {
          comment[item.field] = item.value;
        });
      }

      let listtstt = self.getCheckedChild();
      let params = {
        id: listtstt[0].userBookLessonId,
        comment: JSON.stringify(comment),
        swimmingRings: this.$refs.commentRef.courseForm.swimmingRings,
        gold: this.$refs.commentRef.courseForm.gold
          ? Number(this.$refs.commentRef.courseForm.gold)
          : null,
        remark: this.$refs.commentRef.courseForm.remark

      };
      this.buttonLoading = true;
      updateCourseEval(params)
        .then((response) => {
          if (response.code == 20000) {
            this.$message.success("提交成功");
            this.evaluation = false;
            this.redioDay = null;
            this.flechList();
          }
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
    qlSwCircle() {
      // this.listLoading = true;

      let param = {
        // storeFrontId: 2201,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
      };
      qlSwCircle(param).then((response) => {
        // this.listLoading = false;
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        this.swimInfoTable = date;
        console.log(this.swimInfoTable, ' this.swimInfoTable=======')

      });
    },
    //查询课程配置
    lessons() {
      let self = this
      let listtst = this.getCheckedChild();
      console.log(listtst, 'listtst========')
      lessonsGET({ id: listtst[0].storeLessonId }).then((res) => {
        if (res.code == 20000) {
          this.defaultConfig = res.data
          console.log(this.defaultConfig, 'defaultConfig')

          this.dimensions = res.data.dimensions
          self.visibleMultimedia = true
          self.$nextTick(() => {
            self.$refs.multimediaRef.getFetch();
          });
        }
      })
    },
    //查询课程配置
    lessonss() {
      let self = this
      let listtst = this.getCheckedChild();
      console.log(listtst, 'listtst========')
      lessonsGET({ id: listtst[0].storeLessonId }).then((res) => {
        if (res.code == 20000) {
          this.defaultConfig = res.data
          console.log(this.defaultConfig, 'defaultConfig')

          this.dimensions = res.data.dimensions
          self.evaluation = true
          self.$nextTick(() => {
            self.$refs.commentRef.getFetch();
          });
        }
      })
    },
    // 消费 添加
    clickProduct() {
      this.form.push({
        payWay: "",
        goodsId: "",
      })
    },
    // 消费 删除
    deleProduct(index) {
      this.form.splice(index, 1)
    },
    // 跟进安排 跟进人 加号
    jumpImg() {
      this.userForm.follow.push({
        follup: ''
      })
    },
    // 跟进安排 跟进人 减号
    deleteImg(index) {
      this.userForm.follow.splice(index, 1);
    },
    // 跟进安排 取消
    resetForm() {
      this.$refs.userForm.resetFields();
    },
    // 跟进安排 确认
    handleSubmit() {
      let param = {
        template: 1,
        publisher: globaldata.getAdminStore().id,
        type: 2,
        intentionLevel: 1,
        currentStage: 1,
        intentionLevel: 1,
        ...this.userForm
      }
      commitRecord(param).then((res) => {
        console.log(res, 'userForm=========')
        if (res.code == 20000) {
          this.$message.success("跟进安排成功");
          this.followUp = false;
          this.flechList();
        }
      })
      // this.$refs.userForm.validate((valid) => {
      //   if (valid) {
      //     alert('submit!');
      //   } else {
      //     console.log('error submit!!');
      //     return false;
      //   }
      // });
    },
    // 跟进安排 确认
    handleSubmitt(formName) {

      if (this.qLessonsForm.dayTime == '') {
        this.$message.error('请选择更改日期');
        return
      }
      if (this.qLessonsForm.oldBookId == '') {
        this.$message.error('请选择课程');
        return
      }
      let osf = this.getCheckedChild()
      console.log(osf, 'refs.qLessonsForm')

      let items = [{
        childId: osf[0].childId,
        oldBookId: osf[0].userBookLessonId,
        userId: osf[0].userId,
      }]
      let prams = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        adminId: globaldata.getAdminStore().id,
        adminWord: '',
        items: items,
        releaseLessonId: this.qLessonsForm.oldBookId
      }
      batcheChangeBook(prams).then((res) => {
        if (res.code == 20000) {
          this.changeTime = false
          this.flechList();
        }
      })
    },
    // 打开弹窗
    clickManage(val) {
      let self = this
      switch (val) {
        case 1:
          if (this.isVip == 0) return this.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
          let lis = this.getCheckedChild();
          if (lis && lis.length) {
            if (lis.length == 1) {
              if (lis[0].singIn != 0) {
                self.selectAll()
                self.userForm.userId = lis[0].userId
                self.userForm.cardId = lis[0].userBuyCardId
                self.userForm.userPhoneNumber = lis[0].userPhoneNumber
                self.userForm.childName = lis[0].childName
                self.userForm.childPetName = lis[0].childPetName
                self.userForm.gender = lis[0].gender == 1 ? '男' : '女'
                self.userForm.userBirthday = lis[0].userBirthday
                self.followUp = true
              } else {
                self.$message.error('请选择已签到的学生');
              }
            } else {
              self.$message.error('请选择一条数据');
            }
          } else {
            self.$message.error('请选择一条数据');
          }
          break;
        case 2:
          if (this.isVip == 0) return this.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
          this.teacherAllot.serviceTeacher = ''
          //查询老师接口
          let list = self.getCheckedChild();
          if (list && list.length) {
            if (list.length == 1) {
              if (list[0].singIn != 0) {
                self.selectAllS(list)
                self.distribution = true
              } else {
                self.$message.error('请选择已签到的学生');
              }
            } else {
              self.$message.error('请选择一条数据');
            }
          } else {
            self.$message.error('请选择一条数据');
          }
          break;
        case 3:
          if (this.isVip == 0) return this.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
          this.teacherAllot.batherTeacherId = ''
          let lists = this.getCheckedChild();
          if (lists && lists.length) {
            if (lists.length == 1) {
              if (lists[0].singIn != 0) {
                //查询洗澡老师接口
                self.selectAll()
                self.takeBath = true
              } else {
                self.$message.error('请选择已签到的学生');
              }
            } else {
              self.$message.error('请选择一条数据');
            }
          } else {
            self.$message.error('请选择一条数据');
          }
          break;
        case 4:
          if (this.isVip == 0) return this.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
          this.findTemp();
          this.disabledtd = false
          this.Settings = true
          break;
        case 5:
          this.form = [{
            payWay: "",
            goodsId: "",
          }]
          let listt = this.getCheckedChild();
          this.searchG()

          if (listt && listt.length) {
            if (listt.length == 1) {
              this.consume = true
            } else {
              self.$message.error('请选择一条数据');
            }
          } else {
            self.$message.error('请选择一条数据');
          }
          break;
        case 6:
          this.$alert('签到成功', '', {
            confirmButtonText: '确定',
            showConfirmButton: false,
            center: true,
            callback: action => {
              // this.$message({
              //   type: 'info',
              //   message: `action: ${action}`
              // });
            }
          });
          break;
        case 7:
          this.$alert('签到成功', '', {
            confirmButtonText: '确定',
            showConfirmButton: false,
            center: true,
            callback: action => {
              // this.$message({
              //   type: 'info',
              //   message: `action: ${action}`
              // });
            }
          });
          break;
        case 8:
          this.qLessonsForm = {
            userPhoneNumber: '',// 手机号
            childName: '',
            childPetName: '',
            dayTime: '',
            oldBookId: '',
            classStartTime: '',
            classEndTime: ''
          }
          let listts = this.getCheckedChild();
          if (listts && listts.length) {
            if (listts.length == 1) {
              if (listts[0].singIn == 0) {
                this.qLessonsForm.userPhoneNumber = listts[0].userPhoneNumber
                this.qLessonsForm.childName = listts[0].childName
                this.qLessonsForm.childPetName = listts[0].childPetName
                this.changeTime = true
              } else {
                self.$message.error('已签到不能更改日期');
              }

            } else {
              self.$message.error('请选择一条数据');
            }
          } else {
            self.$message.error('请选择一条数据');
          }
          break;
        case 9:
          let listtst = this.getCheckedChild();
          if (listtst && listtst.length) {
            if (listtst.length == 1) {
              this.batcheList.userPhoneNumber = listtst[0].userPhoneNumber
              this.batcheList.childName = listtst[0].childName
              this.abolish = true
            } else {
              self.$message.error('请选择一条数据');
            }
          } else {
            self.$message.error('请选择一条数据');
          }
          break;
        case 10:
          this.$message({
            type: 'info',
            message: `导出成功`
          });
          break;
        case 11:
          if (this.isVip == 0) return this.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
          let listd = self.getCheckedChild();
          if (listd && listd.length) {
            if (listd.length == 1) {
              if (listd[0].singIn != 0) {
                self.lessons() // 查询课程配置
                self.checkedId = listd[0].userBookLessonId;
              } else {
                self.$message.error('请选择已签到的学生');
              }
            } else {
              self.$message.error('请选择一条数据');
            }
          } else {
            self.$message.error('请选择一条数据');
          }
          break;
        case 12:
          if (this.isVip == 0) return this.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
          let listtstt = self.getCheckedChild();
          if (listtstt && listtstt.length) {
            if (listtstt.length == 1) {
              if (listtstt[0].singIn != 0) {
                self.checkedId = listtstt[0].storeLessonId;
                self.lessonss() // 查询课程配置
              } else {
                self.$message.error('请选择已签到的学生');
              }
            } else {
              self.$message.error('请选择一条数据');
            }
          } else {
            self.$message.error('请选择一条数据');
          }
          break;
      }
    },

    // 选中周几
    clcikPitchUp(index, v) {
      console.log(index, v, '==========')
      this.pitchUp = index
      this.queryParam.days = timeUtils.transDayInt(v.day)
      this.queryParam.times = ''
      this.flechList();

    },
    clickChanges() {
      this.queryParam.days = ''
      this.pitchUp = 0
    },
    // 重置
    handleResetSearch() {
      this.queryParam = {
        lessonName: '',//课程名称
        userName: '',
        userPhone: '', //家长手机号
        userChildrenName: '',
        userChildrenPetName: '',
        userChildrenLevelDes: '',
        optionsSignStatuValue: "",
        optionsBookStatuValue: "",
        userPhoneNumber: '',
        childName: '',
        // dayTime:new Data(),
        day: null,
        days: '',
        times: '',
        //分页查询
        pageNum: 1,//当前第几页
        totalPage: 1, //总共页数
        pageSize: 10,
        pageSizes: [20, 50, 100],
      }
      this.pitchUp = 0
      this.flechList();
    },
    praseLessonName(lesson) {
      if (lesson.lessonTemplateId == enumsUtil.lessonTemplateIdBS()) {
        let tStr = timeUtils.transTimeHM(lesson.classStartTime) + '~' + timeUtils.transTimeHM(lesson.classEndTime);
        let ms = "";
        if (lesson.startMonth < 8) {
          ms = "婴儿"
        } else {
          ms = "幼儿"
        }
        return lesson.name + '/' + ms + '(' + tStr + ')';
      } else {
        let tStr = timeUtils.transTimeHM(lesson.classStartTime) + '~' + timeUtils.transTimeHM(lesson.classEndTime);
        return lesson.name + '(' + tStr + ')';
      }

    },
    qlDayReleaseLessons() {
      let dayTime = "";
      if (this.isRegular) {
        dayTime = timeUtils.transDayInt(this.weekDay[this.selectWeekDay].dayTime);
      } else {
        if (commonUtils.isStringNull(this.bookInfo.dayTime)) {
          return;
        }
        dayTime = timeUtils.transDayInt(this.bookInfo.dayTime);
      }
      let param = {
        dayTime: dayTime,
        lessonTemplateId: this.queryParam.lessonTemplateId,
        storeFrontId: globaldata.getAdminStore().storeFrontId
      }
      qlDayReleaseLessons(param).then(response => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        this.storeReleaseLessons = data;
      })

    },
    changeDay(val) {
      this.storeReleaseLessons = []
      this.qlDayReleaseLessons();
    },
    onClickBookLesson() {
      this.adminNotAttendBookLesson();
    },

    adminNotAttendBookLesson() {
      let that = this
      let param = {
        userId: this.bookInfo.userId,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        releaseLessonId: this.bookInfo.storeReleaseLessonId,
        userBuyCardId: this.bookInfo.userBuyCardId,
        userChildrenId: this.bookInfo.userChildrenId,
        refundFlag: this.bookInfo.refundFlag,
        bookLessonId: this.bookInfo.bookLessonId,
        remark: "未签到补约课",
      }
      adminNotAttendBookLesson(param).then(response => {
        this.visibleDlgBook = false;
        if (response.code === 20000) {
          messageUtils.successMsg(this, response.message);
          this.flechList();
        }
      })
    },
    handleBookLesson(row) {
      if (this.isVip == 0 || this.isVip == 1) return this.$message.warning("该功能需要开通SVIP功能，请先开通相关权益！");
      this.refreshBookDlg = new Date().getTime();
      this.visibleDlgBook = true;
      this.bookInfo.userId = row.userId
      this.bookInfo.userBuyCardId = row.userBuyCardId
      this.bookInfo.userChildrenId = row.userChildrenId
      this.bookInfo.bookLessonId = row.userBookLessonId
    },
    getClassroom(list) {
      this.allClassroom.push({ id: 0, classroomName: "无" })
      this.allClassroom = this.allClassroom.concat(list);
      // console.info('allClassroom');
      // console.info(this.allClassroom);
    },
    getClassroomById(id) {
      //console.info(this.allClassroom.length);
      for (let i = 0; i < this.allClassroom.length; ++i) {
        if (this.allClassroom[i].id == id) {
          //console.info(this.allClassroom[i].classroomName);
          return this.allClassroom[i].classroomName;
        }
      }
      return ""
    },
    //商品
    searchG() {
      searchGET({ shopFrontId: globaldata.getAdminStore().storeFrontId }).then((res) => {
        if (res.code == 20000) {
          this.searchList = res.data.list
        }
      })
    },
    doAfterService(row) {
      this.visibleAfterClassService = true
      this.serviceRow = row
      // 因为是用了原来服务那边的，所以这边的ID要替换成实际记录的ID
      this.serviceRow.id = row.userBookLessonId
      this.onGetServiceAllItemOptions()
    },
    onBtnOKAfterService(param) {
      this.doRefreshWord(true, 2, param);
    },
    beforeHandleCommand(index, row, command) {
      return {
        'index': index,
        'row': row,
        'command': command
      }
    },
    /**
    * 获取所有服务的选项
    */
    onGetServiceAllItemOptions() {
      let param = {
        id: globaldata.getAdminStore().storeFrontId
      }
      getClassServiceAllItem(param).then(response => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        this.serviceItems = data;
        this.afterClassServiceDetailrefresh = new Date().getTime();
      })

    },
    doRefreshWord(show, wordType, tData) {
      this.wordType = wordType;
      this.tData = tData;
      this.refreshWord = new Date().getTime();
      this.showWordDlg = show;
    },
    closeWordDlg() {
      this.wordType = 0;
      this.refreshWord = new Date().getTime();
      this.showWordDlg = false;
    },
    rowClick(row, column, event) {
      // console.log(row,'=============')
      this.selectRow = row;
    },
    handleCheckSelect() {
      if (commonUtils.isObjectNull(this.selectRow)) {
        messageUtils.errorMsg(this, "请先选择一条信息");
        return false;
      }
      return true;
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {

      //指定坐标rowIndex ：行，columnIndex ：列
      if (row.singIn == 1) {
        if (columnIndex == 10) {
          return 'background:green;text-align:center;color:white'
        }
      }
      if ((row.remainingClass < row.parentingSurplusHours) && row.remainingClass !== null ) {
        if (columnIndex == 12) {
          return 'background:#FAA0A0;text-align:center;color:white'
        }
      }
      return 'text-align:center' //rgb(105,0,7)
    },
    getStoreWorkersInfo(list) {
      this.storeWokers = list;
      globaldata.getStoreLessonTemplate(this.getStoreLessonTemplate);
      this.calRedioDay();
    },
    getWorker(id) {
      for (let i = 0; i < this.allWorker.length; ++i) {
        if (this.allWorker[i].id == id) {
          return this.allWorker[i].name;
        }
      }
      return ""
    },
    getStoreGoods(list) {
      this.allGoodsList = this.allGoodsList.concat(list.list);
    },
    getGoods(id) {
      for (let i = 0; i < this.allGoodsList.length; ++i) {
        if (this.allGoodsList[i].goodsId == id) {
          return this.allGoodsList[i].goodsName;
        }
      }
      return ""
    },
    getStoreLessonTemplate(list) {
      this.storeLessonTemplateList = list;
      this.flechList();
    },
    getStoreSwimCircle(list) {

      this.storeSwCircleList = list;
    },
    getStoreWorkersInfoById(id) {

      if (commonUtils.isObjectNull(id)) {
        return "";
      }
      for (let i = 0; i < this.storeWokers.length; ++i) {
        if (this.storeWokers[i].id == id) {
          return this.storeWokers[i];
        }
      }
      return null;
    },
    getStoreLessonTemplateById(id) {
      for (let i = 0; i < this.storeLessonTemplateList.length; ++i) {
        if (this.storeLessonTemplateList[i].id == id) {
          return this.storeLessonTemplateList[i];
        }
      }
      return null;
    },

    calRedioDay() {
      let nowDay = new Date();
      let dm = timeUtils.getDayMilSec();
      for (let i = 0; i < this.redioWeek.length; ++i) {
        let dayTime = nowDay.getTime() + (dm) * i;
        let date = new Date(dayTime);
        this.redioWeek[i].day = formatDate(date, 'yyyy-MM-dd');
        let weekDay = timeUtils.getWeekDay(date);
        this.redioWeek[i].weekDay = weekDay;
      }

    },
    onChangeDay(val) {
      let day = this.redioWeek[val].day;
      this.redioDay = day;
      this.fechListUserBookLesson(day);
    },
    fechListUserBookLesson(day) {

      this.listLoading = true;
      let now = new Date();
      day = formatDate(now, 'yyyy-MM-dd')
      timeUtils.transDayInt(day);

      let dayTime = this.queryParam.times ? this.queryParam.times : this.queryParam.days ? this.queryParam.days : timeUtils.transDayInt(day);
      // if (commonUtils.isObjectNull(day)) {

      //   this.curDay = day;
      // } else {
      //   // let nowStr= formatDate(day, 'yyyy-MM-dd')
      //   dayTime = timeUtils.transDayInt(day);
      //   this.curDay = day;
      // }
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        storeReleaseLessonId: this.queryParam.storeReleaseLessonId,
        userPhone: this.queryParam.userPhone,
        userPhoneNumber: this.queryParam.userPhoneNumber,
        childName: this.queryParam.childName,
        // childName: this.queryParam.userChildrenName,
        childPetName: this.queryParam.userChildrenPetName,
        bookStatu: this.queryParam.optionsBookStatuValue,
        singIn: this.queryParam.optionsSignStatuValue,
        lessonName: this.queryParam.lessonName,
        dayTime: dayTime,
        lessonTemplateId: enumsUtil.lessonTemplateIdCF(),
        pageNum: this.queryParam.pageNum,//当前第几页
        pageSize: this.queryParam.pageSize
      }

      const loading = this.myLoading();

      fechListReleaseLessonDetail(param).then(response => {
        loading.close();
        this.listLoading = false;
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        console.log(date, 'date----------------');
        // return

        date.forEach(item => {
          if (item.goodsId != null) {
            let goods = item.goodsId;
            goods = goods.toString().split(",");
            let goodsName = "";
            for (var i = 0; i < goods.length; i++) {
              goodsName = goodsName + this.getGoods(goods[i]) + ",";
            }
            //console.info(goodsName);
            item.goodsName = goodsName.toString().replace(/^(\s|,)+|(\s|,)+$/g, '');
          }
        });
        console.log(date, 'date---------------11-');

        // this.queryParam.totalPage = date.total;
        this.refreshData(date);

      })
    },
    calRedioDay() {
      let nowDay = new Date();
      let dm = timeUtils.getDayMilSec();
      for (let i = 0; i < this.redioWeek.length; ++i) {
        let dayTime = nowDay.getTime() + (dm) * i;
        let date = new Date(dayTime);
        this.redioWeek[i].day = formatDate(date, 'yyyy-MM-dd');
        let weekDay = timeUtils.getWeekDay(date);
        this.redioWeek[i].weekDay = weekDay;
      }
      // console.log(this.redioWeek,'this.redioWeek======')
    },
    setServiceTeacher(data, item) {
      // alert(JSON.stringify(data))
      data.selectedTeacher = item.id
      this.doRefreshWord(true, 1, data);
    },

    setBathWorker(data, item) {
      // alert(JSON.stringify(data))
      data.selectedTeacher = item.id
      this.doRefreshWord(true, 3, data);
    },

    handleWord(wordType, tData) {
      if (this.workerWordID == 1) {    // 老师分配
        let list = this.getCheckedChild();
        let param = {
          selectedTeacher: this.teacherAllot.serviceTeacher,
          id: list[0].id,
          userBookLessonId: list[0].userBookLessonId,
          adminWord: tData.adminWord
        }
        setServiceTeacher(param).then((res) => {
          if (res.code == 20000) {
            this.teacherAllot = {
              serviceTeacher: '', //服务老师id
            }
            this.takeBath = false
            this.redioDay = null;
            this.distribution = false
            this.flechList();
          }
        })
      } else if (this.workerWordID == 2) {  //洗澡老师分配
        let list = this.getCheckedChild();
        let param = {
          selectedTeacher: this.teacherAllot.batherTeacherId,
          id: list[0].id,
          userBookLessonId: list[0].userBookLessonId,
          adminWord: tData.adminWord
        }
        setBathWorker(param).then((res) => {
          if (res.code == 20000) {
            this.teacherAllot = {
              batherTeacherId: '', //服务老师id
            }
            this.takeBath = false
            this.redioDay = null;
            this.takeBath = false
            this.flechList();
          }
        })
      } else if (this.workerWordID == 3) {  //课评
        let self = this
        let comment = {};
        if (this.$refs.commentRef.courseForm.dimensions && this.$refs.commentRef.courseForm.dimensions.length) {
          this.$refs.commentRef.courseForm.dimensions.map((item) => {
            comment[item.field] = item.value;
          });
        }

        let listtstt = self.getCheckedChild();
        let params = {
          adminWord: tData.adminWord,
          id: listtstt[0].userBookLessonId,
          comment: JSON.stringify(comment),
          swimmingRings: this.$refs.commentRef.courseForm.swimmingRings,
          gold: this.$refs.commentRef.courseForm.gold
            ? Number(this.$refs.commentRef.courseForm.gold)
            : null,
          remark: this.$refs.commentRef.courseForm.remark

        };
        this.buttonLoading = true;
        updateCourseEval(params)
          .then((response) => {
            if (response.code == 20000) {
              this.$message.success("提交成功");
              this.evaluation = false;
              this.redioDay = null;
              this.flechList();
            }
          })
          .finally(() => {
            this.buttonLoading = false;
          });
      } else if (this.workerWordID == 4) {  //多媒体
        let self = this
        console.log(self.$refs.multimediaRef.$refs.soundRecord.audio, 'self.$refs.multimediaRef.$refs.soundRecord.audio===========')

        let listtst = this.getCheckedChild();
        let params = {
          adminWord: tData.adminWord,
          identityId: listtst[0].userBookLessonId,
          video: self.$refs.multimediaRef.multimediaForm.video,
          image: self.$refs.multimediaRef.multimediaForm.image,
          remark: self.$refs.multimediaRef.multimediaForm.remark,
          audio: self.$refs.multimediaRef.$refs.soundRecord.audio
        };
        self.buttonLoading = true;
        updateCourseMedia(params)
          .then((response) => {
            if (response.code == 20000) {
              self.$message.success("提交成功");
              self.visibleMultimedia = false;
              self.checkedId = null
              self.$nextTick(() => {
                self.$refs.multimediaRef.resetForm()

              })
              self.getList();
            }
          })
          .finally(() => {
            this.buttonLoading = false;
          });
      }
      // if (wordType == 1) {
      //   setServiceTeacher(tData).then(response => {
      //     let date = response.data;
      //     if (commonUtils.isObjectNull(date)) {
      //       return;
      //     }
      //     messageUtils.successMsg(this, response.message)
      //     this.closeWordDlg();
      //     // this.$emit('onServiceOk');
      //     this.flechList();
      //   })
      // } else if (wordType == 2) {
      //   this.doWorkerService(tData)
      // } else if (wordType == 3) {
      //   setBathWorker(tData).then(response => {
      //     let date = response.data;
      //     if (commonUtils.isObjectNull(date)) {
      //       return;
      //     }
      //     messageUtils.successMsg(this, response.message)
      //     this.closeWordDlg();
      //     // this.$emit('onServiceOk');
      //     this.flechList();
      //   })
      // }
    },

    doWorkerService(param) {
      console.info('doWorkerService')
      workerService(param).then(response => {
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        messageUtils.successMsg(this, response.message)
        this.closeWordDlg();
        this.visibleAfterClassService = false;
        this.flechList()
      })
    },

    flechList() {
      let day;
      // if (this.redioDay == null) {
      //   day = this.queryParam.day;
      // } else {
      //   day = this.redioDay;
      // }

      this.fechListUserBookLesson(day);
    },

    getoptionsSignStatu(value) {
      if (value == null) {
        return ""
      }
      for (let i = 0; i < this.optionsSignStatu.length; ++i) {
        if (value == this.optionsSignStatu[i].value) {
          return this.optionsSignStatu[i].label
        }
      }

    },

    getoptionsBookStatu(value) {
      if (value == null) {
        return ""
      }
      for (let i = 0; i < this.optionsBookStatu.length; ++i) {
        if (value == this.optionsBookStatu[i].value) {
          return this.optionsBookStatu[i].label
        }
      }
    },
    //刷新页面数据
    refreshData(list) {
      if (commonUtils.isObjectNull(list)) {
        return;
      }
      this.spanArr = []
      let tableDataList = [];
      let totalNum = 0;
      let totalNum2 = 0
      for (let i = 0; i < list.length; ++i) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0
        } else {
          // 判断当前元素与上一个元素是否相同  inAccessCode（批次字段）
          if (list[i].id === list[i - 1].id) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
        let childType = enumsUtil.childBodyType(list[i].type);
        let classDay = timeUtils.transDay(list[i].dayTime)
        let data = {
          number: i + 1,
          id: list[i].id,
          userId: list[i].userId,
          userChildrenId: list[i].childId,
          userBuyCardId: list[i].buyCardId,
          storeReleaseLessonId: list[i].storeReleaseLessonId,
          classDay: classDay,
          classTime: timeUtils.transTimeHM(list[i].classStartTime) + " - " + timeUtils.transTimeHM(list[i].classEndTime),
          lessonName: list[i].name,
          userPhoneNumber: list[i].userPhoneNumber,
          userBirthday: list[i].userBirthday,
          birthday: list[i].birthday,
          gender: list[i].gender,
          childName: list[i].childName,
          childPetName: list[i].childPetName,
          monthCount: list[i].monthCount,
          childType: childType,
          childLevel: list[i].childLevel,
          singInTime: list[i].singInTime,
          multimediaId: list[i].multimediaId,
          lessonEvaluationId: list[i].lessonEvaluationId,
          singIn: list[i].singIn,
          singInDes: this.getoptionsSignStatu(list[i].singIn),
          bookStatu: list[i].bookStatu,
          bookStatuDes: this.getoptionsBookStatu(list[i].bookStatu),
          bookTime: list[i].bookTime,
          userBookLessonId: list[i].userBookLessonId,
          childId: list[i].childId,
          lessonTemplateId: list[i].lessonTemplateId,
          lessonTemplateType: this.getStoreLessonTemplateById(list[i].lessonTemplateId).type,
          cancelReason: list[i].cancelReason,
          bookRemark: list[i].bookRemark,
          maxBookPeople: list[i].maxBookPeople,
          afterClassService: list[i].afterClassService,
          teachersInfo: list[i].teachersInfo,
          serviceWorker: this.getStoreWorkersInfoById(list[i].serviceTeacher).name,
          bathTeacher: list[i].bathTeacher,
          needSetTeacherFlag: list[i].needSetTeacherFlag,
          needServiceFlag: list[i].needServiceFlag,
          goodsId: list[i].goodsId,
          goodsName: list[i].goodsName,
          storeLessonId: list[i].storeLessonId,
          needSetBathWorker: list[i].needSetBathWorker,
          notAttendFlag: list[i].notAttendFlag,
          newLessonsId: list[i].newLessonsId,
          checked: false,
          // teacherList: [
          //   { name: this.getStoreWorkersInfoById(list[i].headTeacher).name, id: list[i].headTeacher },
          //   { name: this.getStoreWorkersInfoById(list[i].assistantTeacher).name, id: list[i].assistantTeacher }
          // ],
          classRoomName: this.getClassroomById(list[i].classroomId),
          name: list[i].name,
          remainingClass: list[i].remainingClass,
          parentingSurplusHours: list[i].parentingSurplusHours,
          cardExperienceDisplay: list[i].cardExperienceDisplay,
        };
        if (list[i].userPhoneNumber != null && list[i].userPhoneNumber != '') {
          totalNum = totalNum + 1
        }
        if (list[i].userPhoneNumber != null && list[i].userPhoneNumber != '' && list[i].cardExperience != 0) {
          totalNum2 = totalNum2 + 1
        }
        tableDataList.push(data);
      }
      console.log(tableDataList,'tableDataList=============')
      this.totalChildren = totalNum
      this.totalChildren2 = totalNum2
      this.tableData = tableDataList;
    },

    //点击查询按钮
    onBtnSearch() {
      this.redioDay = null;
      this.flechList();
    },
    handleSelectionChange(val) {
      this.selectionList = val
      this.checkedId = val[0].id;
      console.log(this.selectionList, val, this.checkedId, 'selectionList========')
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {

      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 3) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },


    handleCurrentChange(val) {
      this.queryParam.pageNum = val;
      this.flechList();
    },
    handleSizeChange(val) {
      this.queryParam.pageSize = val;
      this.flechList();
    },

    beforeHandleCommand(index, row, command) {
      return {
        'index': index,
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      switch (command.command) {
        case "eSure"://
          this.showVisibleDlgExamine(command.index, command.row);
          break;
        case "sign"://签到
          this.showVisableSignDlg(command.index, command.row);
          break;
        case "afterClass"://课后服务
          this.showDlgafterClassService(command.row);
          break;
        case "cancelBook"://取消预约
          this.showCancelBookDlg(command.row);
          break;
        case "serviceDetial"://服务详情
          this.showDlgafterClassServiceDetail(command.row);
          break;

      }
    },

    showDlgafterClassService(row) {
      this.showDlgService(row, 1);
      this.visibleAfterClassService = true;
    },
    showDlgafterClassServiceDetail(row) {
      this.showDlgService(row, 2);
      this.visibleAfterClassServiceDetail = true;
    },

    /**
     *
     * @param type 1 表示 服务  2 表示查看服务详情
     */
    showDlgService(row, type) {
      let swCircle = [];
      for (let i = 0; i < this.storeSwCircleList.length; ++i) {
        if (this.storeSwCircleList[i].statu == 0) {
          swCircle.push(this.storeSwCircleList[i].name);
        }
      }
      if (row.isServiced) {
        let serviceDetail = JSON.parse(row.afterClassService)
        this.afterClassServiceDetail = {
          type: type,
          userBookLessonId: row.id,
          lessonName: row.lessonName,
          childName: row.childName,
          lessonTemplateId: row.lessonTemplateId,
          swCircle: swCircle,
          height: serviceDetail.height,
          weight: serviceDetail.weight,
          temperature: serviceDetail.temperature,
          swCircle: serviceDetail.swCircle,
          evaluate: serviceDetail.evaluate
        }
      } else {
        this.afterClassServiceDetail = {
          type: type,
          userBookLessonId: row.id,
          lessonName: row.lessonName,
          childName: row.childName,
          lessonTemplateId: row.lessonTemplateId,
          swCircle: swCircle,
        }
      }

      this.AfterClassServiceType = type;
      this.afterClassServiceDetailrefresh = new Date().getTime();
    },

    onBtnOKSerivce() {
      this.visibleAfterClassService = false;
    },

    //添加一个
    handleCreateOne() {
      this.visibleDlgAdd = true;
    },

    handeleExamine(val) {
      //通过审核
      let param = {
        adminId: globaldata.getAdminStore().id,
        id: this.examineParam.id
      }
      if (val == true) {
        passbook(param).then(response => {
          let date = response.data;
          if (commonUtils.isObjectNull(date)) {
            return;
          }
          messageUtils.successMsg(this, response.message);
          this.visibleDlgExamine = false;
        })
      } else {
        this.visibleDlgExamine = false;
      }
    },

    showVisibleDlgExamine(index, row) {
      this.examineParam = {
        id: row.id,
        lessonName: row.lessonName,
        userName: row.userName,
        userPhone: row.userPhone,
        childName: row.childName,
        childPetName: row.childPetName,
        childLevel: row.childLevel,
        examineStatu: row.examineStatu,
        examineReason: ""
      }
      this.visibleDlgExamine = true;
    },

    showVisableSignDlg(index, tableData) {
      this.examineParam = {
        id: tableData.id,
      }
      this.$confirm('确认签到?', '温馨提示', {
        confirmButtonText: '确定签到',
        cancelButtonText: '取消',
        type: 'success ',
      }).then(() => {
        this.handeleSign()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消签到'
        });
      });
    },

    handeleSign() {
      let param = {
        adminId: globaldata.getAdminStore().id,
        id: this.examineParam.id
      }
      adminSign(param).then(response => {
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        messageUtils.successMsg(this, response.message);
        this.flechList();
      })
    },

    showCancelBookDlg(row) {
      this.cancleBook = {
        id: row.id,
        cancelReason: "",
      }
      this.visibleCancel = true;
    },
    handeleCancelBook() {
      let param = {
        adminId: globaldata.getAdminStore().id,
        id: this.cancleBook.id,
        reason: this.cancleBook.cancelReason,
      }
      adminSign(param).then(response => {
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        messageUtils.successMsg(this, response.message);
        this.flechList();
      })
    },
    //批量取消
    handleBatchCancel() {
      let list = this.getCheckedChild();
      if (list.length <= 0) {
        messageUtils.errorMsg(this, "请勾选会员");
        return;
      }


      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        adminId: globaldata.getAdminStore().id,
        adminWord: "",
        reaseon: "",
        items: [],
      }
      for (let i = 0; i < list.length; ++i) {
        let item = {
          id: list[i].userBookLessonId,
          childName: list[i].childName,
        }
        param.items.push(item);
      }
      const loading = this.myLoading("取消预约中,请稍后!!1");
      batcheCancelBook(param).then(response => {
        loading.close();
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        if (data.success == true) {
          messageUtils.successMsg(this, data.message);
          this.flechList();
        } else {
          messageUtils.errorMsg(this, data.message);
        }
      })

    },
    //批量签到
    handleBatchSingIn() {
      let list = this.getCheckedChild();
      if (list.length <= 0) {
        messageUtils.errorMsg(this, "请勾选会员");
        return;
      }

      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        adminId: globaldata.getAdminStore().id,
        adminWord: "",
        items: [],
        notAttendFlag: false,
      }
      for (let i = 0; i < list.length; ++i) {
        let item = {
          id: list[i].userBookLessonId,
          childName: list[i].childName,
        }
        param.items.push(item);
      }
      const loading = this.myLoading("签到中,请稍后!!");
      batcheSingIn(param).then(response => {
        loading.close();
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        if (data.success == true) {
          messageUtils.successMsg(this, data.message);
          this.flechList();
        } else {
          messageUtils.errorMsg(this, data.message);
        }

      })
    },

    //批量未到签到
    handleNotAttendBatchSingIn() {
      if (this.isVip == 0 || this.isVip == 1) return this.$message.warning("该功能需要开通SVIP功能，请先开通相关权益！");
      let list = this.getCheckedChild();
      if (list.length <= 0) {
        messageUtils.errorMsg(this, "请勾选会员");
        return;
      }

      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        adminId: globaldata.getAdminStore().id,
        adminWord: "",
        items: [],
        notAttendFlag: true,
      }
      for (let i = 0; i < list.length; ++i) {
        let item = {
          id: list[i].userBookLessonId,
          childName: list[i].childName,
        }
        param.items.push(item);
      }
      const loading = this.myLoading("签到中,请稍后!!");
      batcheSingIn(param).then(response => {
        loading.close();
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        if (data.success == true) {
          messageUtils.successMsg(this, data.message);
          this.flechList();
        } else {
          messageUtils.errorMsg(this, data.message);
        }

      })
    },

    //批量更改预约
    handleBatchChangeBook() {
      let list = this.getCheckedChild();
      if (list.length <= 0) {
        messageUtils.errorMsg(this, "请勾选会员");
        return;
      }
      this.visibleDlgSelectLesson = true;
    },

    //批量通过审核
    handleBatchPassBook() {
      let list = this.getCheckedChild();
      if (list.length <= 0) {
        messageUtils.errorMsg(this, "请勾选会员");
        return;
      }
      let param = {
        adminId: globaldata.getAdminStore().id,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        ids: []
      }
      for (let i = 0; i < list.length; ++i) {
        param.ids.push(list[i].userBookLessonId);
      }
      // param.ids = JSON.stringify(param.ids);
      const loading = this.myLoading();
      batchAdminPassBook(param).then(response => {
        loading.close();
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        if (data == true) {
          messageUtils.successMsg(this, response.message);
          this.flechList();
        } else {
          messageUtils.errorMsg(this, response.message);
        }

      })
    },


    //获取选中的会员
    getCheckedChild() {
      let list = [];

      for (let i = 0; i < this.tableData.length; ++i) {
        if (this.tableData[i].checked == true) {
          list.push(this.tableData[i]);
        }
      }
      console.log(list, '111111111111')

      return list;
    },
    onSelectLesson(releaseLesson) {

      this.visibleDlgSelectLesson = false;
      let list = this.getCheckedChild();
      this.doBatchChangeBook(list, releaseLesson);

    },
    doBatchChangeBook(list, releaseLesson) {
      if (commonUtils.isObjectNull(releaseLesson)) {
        return;
      }
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        adminId: globaldata.getAdminStore().id,
        adminWord: "",
        remark: "",
        releaseLessonId: releaseLesson.id,
        items: [],
      }

      for (let i = 0; i < list.length; ++i) {
        let item = {

          oldBookId: list[i].userBookLessonId,
          userId: list[i].userId,
          childId: list[i].userChildrenId,
        }
        param.items.push(item);
      }
      const loading = this.myLoading();
      batcheChangeBook(param).then(response => {
        loading.close();
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        if (data.success == true) {
          messageUtils.successMsg(this, data.message);
          this.flechList();
        } else {
          messageUtils.errorMsg(this, data.message);
        }

      })
    },

    /**
     * 导出按钮事件
     */
    handleExport() {
      const data = this.tableData;//表格数据
      let nowStr = formatDate(new Date(), "yyyy-MM-dd hh:mm:ss")

      var option = {};
      let dataTable = [];
      if (data) {
        for (let i in data) {
          if (data) {

            let obj = {
              '课程ID': data[i].id,
              '上课时间': data[i].classTime,
              '课程名': data[i].lessonName,
              '教练': data[i].teachersInfo,
              '卡号': data[i].userPhoneNumber,
              '会员姓名': data[i].childName,
              '小名': data[i].childPetName,
              '月龄': data[i].monthCount,
              '级别判定': data[i].childLevel,
              '预约备注': data[i].bookRemark,
            }
            dataTable.push(obj);
          }
        }
      }
      option.fileName = '亲子游预约表_' + nowStr;
      option.datas = [
        {
          sheetData: dataTable,
          sheetName: this.curDay,
          sheetFilter: ['课程ID', '上课时间', '课程名', '教练', '卡号', '会员姓名', '小名', '月龄', '级别判定', '预约备注'],
          sheetHeader: ['课程ID', '上课时间', '课程名', '教练', '卡号', '会员姓名', '小名', '月龄', '级别判定', '预约备注'],
        }
      ];
      var toExcel = new ExportJsonExcel(
        option,

      );
      toExcel.saveExcel();
      toExcel.close();
    },

    //消费商品
    borrow(row) {
      // let list = this.getCheckedChild();
      // if (list.length <=0){
      //   messageUtils.errorMsg(this,"请勾选会员");
      //   return;
      // }
      this.visibleSth = true;
      this.updateParam.userBuyCardId = row.userBuyCardId;
      this.updateParam.userId = row.userId;
    },

    /**
     * 消费商品提交
     */
    handleBorrowGoods() {
      // let list = this.getCheckedChild()
      this.visibleSth = false;
      let cardList = []
      // for (let i =0;i<list.length;++i ){
      //   let data = {
      //     cardId:list[i].userBuyCardId,
      //     userId:list[i].userId,
      //   }
      //   cardList.push(data);
      // }
      let data = {
        cardId: this.updateParam.userBuyCardId,
        userId: this.updateParam.userId,
      }
      cardList.push(data);
      let param = {
        cardList: cardList,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        goodsId: this.checkList.toString(),
      }
      this.checkList = []
      borrowGoods(param).then(response => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        if (data.success == true) {
          messageUtils.successMsg(this, data.message);
          this.flechList();
        } else {
          messageUtils.errorMsg(this, data.message);
        }
      })
    },

    getGoodsList() {
      let param = {
        shopFrontId: globaldata.getAdminStore().storeFrontId,
      }
      //alert(param.shopFrontId);
      queryGoods(param).then(response => {
        this.listLoading = false;
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        this.totalPage = data.total;
        //console.info(data.list);
        for (var i = 0; i < data.list.length; i++) {
          //console.log(data.list[i])
          let good = {
            value: "", text: "",
          };
          good.value = data.list[i].goodsId;
          good.text = data.list[i].goodsName;
          this.goodsList[i] = good;
        }
        //console.info(this.goodsList);
      })
    }
  }
}
</script>


<style scoped>
.future {
  background: #ECF3FD;
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding: 5px;
}

.future-btn {
  width: 100px;
  height: 40px;
  background: #0E6FB8;
  border-radius: 8px;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
  text-align: center;
}

.future-btm {
  width: 100px;
  height: 40px;
  background: #ECF3FD;
  border-radius: 8px;
  font-size: 14px;
  color: #74798C;
  text-align: center;
  cursor: pointer;
}

.manage {
  background-color: #fff;
  padding: 20px;
  text-align: right;
  margin-top: 20px;
  border-radius: 8px 8px 0 0;
}

.el-form-item {
  text-align: left;
}

/deep/ .el-table .el-table__cell {
  padding: 0px;
}

/deep/ .el-table--enable-row-transition .el-table__body td.el-table__cell {
  padding: 3px 0;
}

/deep/ .el-table th.el-table__cell>.cell {
  /* width: 90%;
    height: auto; */
  background: #ecf3fd;
  /* border-radius: 8px; */
}

/deep/ .el-table__header-wrapper .cell {
  line-height: 60px;
  color: #0d6fb8;
  font-size: 14px;
}

/deep/ .el-table .cell {
  font-size: 14px !important;
}

/deep/ .el-form--inline .el-form-item {
  margin-right: 5px;
}

/deep/ .operator-btn {
  margin-left: 1px !important;
}

/deep/ .el-dialog--center {
  /* border: 2px solid #d0d0d0; */
  border-radius: 10px;
}

/deep/ .el-dialog__header {
  text-align: left;
  /* border-radius: 10px;
    background: #f0f7ff; */
}
</style>





// WEBPACK FOOTER //
// src/views/user-book-lesson/index.vue